import DOMPurify from 'dompurify';

const purify = DOMPurify(window);

/**
 * HTML 문자열을 새니타이즈하여 XSS를 방지합니다.
 * `dangerouslySetInnerHTML`에 전달하기 전에 반드시 이 함수를 거쳐야 합니다.
 */
export function sanitizeHtml(dirty: string): string {
  return purify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'code', 'pre',
      'span', 'div', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'img', 'hr', 'sup', 'sub', 'mark', 'del', 'ins',
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel', 'src', 'alt', 'title', 'class', 'id',
      'width', 'height', 'style', 'colspan', 'rowspan',
    ],
    ALLOW_DATA_ATTR: false,
  });
}

/**
 * 프레젠테이션 슬라이드 등 <style> 태그를 허용해야 하는 경우의 새니타이즈.
 * script 계열은 모두 제거하되 style/layout 관련 태그는 유지합니다.
 */
export function sanitizeSlideHtml(dirty: string): string {
  return purify.sanitize(dirty, {
    ADD_TAGS: ['style'],
    ADD_ATTR: ['class', 'id', 'style'],
    FORCE_BODY: true,
  });
}

/**
 * SVG 콘텐츠(Mermaid 등)를 새니타이즈합니다.
 */
export function sanitizeSvg(dirty: string): string {
  return purify.sanitize(dirty, {
    USE_PROFILES: { svg: true, svgFilters: true },
    ADD_TAGS: ['use'],
  });
}
